import * as React from 'react';
import { clsx } from 'clsx';
import { createLocators } from '@u1/locators';
import useStyles from './Tag.styles';

import { Typography } from '../Typography';

export interface ITagProps {
  variant: 'red' | 'magenta' | 'orange' | 'purple' | 'blue' | 'green';
  label: React.ReactNode;
}

export const tagLocators = createLocators({
  name: 'Tag',
  componentLocators: ['label'],
});

const Tag: React.FC<ITagProps> = ({ variant, label }) => {
  const classes = useStyles();
  const { locators } = tagLocators();

  return (
    <Typography
      as="div"
      variant="label01"
      className={clsx(classes.root, classes[variant])}
      locatorsOverrides={locators.label()}
    >
      {label}
    </Typography>
  );
};

export default Tag;
